import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { client } from "@/lib/api";

let metaCache = null;
export function useMeta() {
  const [meta, setMeta] = useState(metaCache);
  useEffect(() => { if (metaCache) return; client.get("/meta").then(r => { metaCache = r.data; setMeta(r.data); }).catch(() => {}); }, []);
  return meta;
}

export function Shell({ children }) {
  const meta = useMeta();
  return <>
    <header className="nav">
      <Link to="/" className="brand" data-testid="brand-link"><span className="brand-mark">V</span><span>VEZİROĞLU<small>E-İMZA ÇÖZÜMLERİ</small></span></Link>
      <nav><Link to="/paketler" data-testid="nav-packages-link">Paketler</Link><Link to="/kep" data-testid="nav-kep-link">KEP Adresi</Link><Link to="/havale-eft" data-testid="nav-bank-transfer-link">Havale / EFT</Link><Link to="/takip" data-testid="nav-track-link">Sipariş Takibi</Link><Link to="/hesabim" data-testid="nav-customer-link">Müşteri Girişi</Link></nav>
    </header>
    <main>{children}</main>
    <footer>
      <strong>VEZİROĞLU MADEN İNŞAAT TURİZM TARIM SANAYİ TİCARET LİMİTED ŞİRKETİ</strong>
      <span>Yeni Mah. Güllük Cad. No:14B · Çaycuma / Zonguldak · MERSİS: 0925133592900001</span>
      {meta?.company?.tax_number ? <span data-testid="footer-tax">Vergi dairesi / no: {meta.company.tax_office || "—"} · {meta.company.tax_number}</span> : null}
      {meta?.company && <span data-testid="footer-contact">Satış & destek: <a href={`mailto:${meta.company.support_email}`} data-testid="footer-support-email">{meta.company.support_email}</a>{meta.company.phone ? ` · Tel: ${meta.company.phone}` : ""}</span>}
      <a className="btn primary" style={{width:"fit-content"}} href="https://e-tugra.com.tr/scm/" target="_blank" rel="noopener noreferrer" data-testid="footer-scm-download">E-Tuğra SCM İndir</a><nav className="footer-legal" data-testid="footer-legal">
        {[["on-bilgilendirme", "Ön Bilgilendirme Formu"], ["mesafeli-satis", "Mesafeli Satış Sözleşmesi"], ["kvkk", "KVKK Aydınlatma Metni"], ["gizlilik", "Gizlilik ve Çerez Politikası"], ["iade", "İade ve Cayma Hakkı"]].map(([slug, label]) => <Link to={`/sozlesmeler/${slug}`} key={slug} data-testid={`footer-legal-${slug}`}>{label}</Link>)}
        <Link to="/havale-eft" data-testid="footer-bank-transfer">Havale / EFT ile Ödeme</Link>
      </nav>
      <span>E-Tuğra Yetkili Bayisi · Satış ve destek: info@vezimza.com</span>
    </footer>
  </>;
}

export function Field({ name, label, type = "text", value, onChange, placeholder, hint }) {
  return <label>{label}<input required name={name} type={type} value={value} placeholder={placeholder} onChange={onChange} data-testid={`${name}-input`} />{hint && <small className="muted" data-testid={`${name}-hint`}>{hint}</small>}</label>;
}

export function Metric({ label, value }) {
  return <div className="metric"><span>{label}</span><strong>{value ?? "—"}</strong></div>;
}

export function PriceBreakdown({ subtotal, shipping, discount = 0, total, testid = "price-breakdown" }) {
  const fmt = n => new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(n);
  return <div className="price-breakdown" data-testid={testid}>
    <div><span>Ürün Bedeli</span><b data-testid={`${testid}-subtotal`}>{fmt(subtotal)}</b></div>
    <div><span>Kargo Bedeli</span><b data-testid={`${testid}-shipping`}>{fmt(shipping)}</b></div>
    {discount > 0 && <div><span>İndirim</span><b>-{fmt(discount)}</b></div>}
    <div className="total"><span>Genel Toplam</span><b data-testid={`${testid}-total`}>{fmt(total)}</b></div>
  </div>;
}
